import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { WithProviders } from '@atlaskit/editor-common/provider-factory';
import Mention from '../ui/Mention';
import { useIntl } from 'react-intl-next';
import { messages } from '../messages';
import { isResolvingMentionProvider, MentionNameStatus } from '@atlaskit/mention';
import { isPromise } from '@atlaskit/mention/types';
var UNKNOWN_USER_ID = '_|unknown|_';
var MentionAssistiveTextComponent = function MentionAssistiveTextComponent(_ref) {
  var id = _ref.id,
    text = _ref.text,
    providers = _ref.providers,
    accessLevel = _ref.accessLevel,
    mentionProvider = _ref.mentionProvider;
  var _useState = useState(text),
    _useState2 = _slicedToArray(_useState, 2),
    resolvedName = _useState2[0],
    setResolvedName = _useState2[1];
  var intl = useIntl();
  var processName = function processName(name) {
    if (name.status === MentionNameStatus.OK) {
      return "@".concat(name.name || '');
    } else {
      return "@".concat(UNKNOWN_USER_ID);
    }
  };
  useEffect(function () {
    if (mentionProvider) {
      mentionProvider.then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider) {
          var nameDetail;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(!text && isResolvingMentionProvider(provider))) {
                  _context.next = 13;
                  break;
                }
                nameDetail = provider.resolveMentionName(id);
                if (!isPromise(nameDetail)) {
                  _context.next = 10;
                  break;
                }
                _context.t0 = processName;
                _context.next = 6;
                return nameDetail;
              case 6:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));
              case 10:
                return _context.abrupt("return", processName(nameDetail));
              case 11:
                _context.next = 14;
                break;
              case 13:
                return _context.abrupt("return", text);
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).then(function (resolvedName) {
        setResolvedName(resolvedName);
      });
    }
  }, [id, text, mentionProvider]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: 'assistive'
  }, "".concat(intl.formatMessage(messages.mentionsNodeLabel), " ").concat(resolvedName)), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Mention, {
    id: id,
    text: resolvedName,
    accessLevel: accessLevel,
    providers: providers
  })));
};
export var MentionNodeView = function MentionNodeView(props) {
  var providerFactory = props.providerFactory;
  var _props$node$attrs = props.node.attrs,
    id = _props$node$attrs.id,
    text = _props$node$attrs.text,
    accessLevel = _props$node$attrs.accessLevel;
  var renderAssistiveTextWithProviders = function renderAssistiveTextWithProviders(providers) {
    var _ref3 = providers,
      mentionProvider = _ref3.mentionProvider;
    return /*#__PURE__*/React.createElement(MentionAssistiveTextComponent, {
      mentionProvider: mentionProvider,
      id: id,
      text: text,
      providers: providerFactory,
      accessLevel: accessLevel
    });
  };
  return /*#__PURE__*/React.createElement(WithProviders, {
    providers: ['mentionProvider', 'profilecardProvider'],
    providerFactory: providerFactory,
    renderNode: renderAssistiveTextWithProviders
  });
};